export const IMAGE_ROOT = "https://zebrarobotics.com/assets/zebra_images";
